
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"61","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.5 17.5l-20-10-20 10m40 0l-20 10m20-10v25l-20 10m0-25l-20-10m20 10v25m-20-35v25l20 10","stroke":"currentColor","stroke-width":"1.5","stroke-linejoin":"round"}})])
          )
        }
      }
    